/**
 *
 * @author Iecisa
 */
export class ClientDataDTO {

    name: string;
    surname: string;
    lastName: string;
    birthDate: string;
    email: string;

    // El prefijo no siempre es el array del multiselect: al venir del servidor, o tras cachear
    // los datos de un guardado, es el id suelto. Declararlo any[] no era cierto y obligaba a
    // convertirlo a mano antes de reutilizar el DTO; ClientService.prefixId() admite ambas formas.
    phonePrefix: any;
    phone: string;

    mobilePhonePrefix: any;
    mobilePhone: string;

    documentNumber: string;
    documentType: string;

    province: string;
    postalCode: string;

    city: string;
    cityDescription: string;
    cityCb: any[];

    roadType: any[];
    address: string;
    number: string;
    portal: string;
    stair: string;
    floor: string;
    door: string;

    insuranceAdvertising: boolean;
    legalServicesAdvertising: boolean;
    politicaClub: boolean;
    condicionesClub: boolean;

    notifications: any[];
    notificationChannel;
}
